import { getAxiosBackendApi2 } from "../helpers/axios"

class CenterServices{

    constructor(){
    }

    addCenter(data){
        return getAxiosBackendApi2().post('volunteers', data)
    }
}

export default new CenterServices()